<template>
  <div id="style-2" style="margin-left: 32px" class="d-flex overflow-auto">
    <div
      v-if="
        computedDataDiligenceById &&
        !computedDataDiligenceById.length &&
        !loading
      "
      class="d-flex flex-column justify-center align-center w-100"
      style="margin-top: 0px; padding-right: 200px"
    >
      <img src="../assets/close-icon.png" alt="" class="mb-2" />
      <img src="../assets/no-data-exercise.png" alt="" class="mb-5" />
      <span style="color: #828282"> Học sinh chưa có thông tin điểm </span>
    </div>
    <div>
      <table
        v-if="computedDataDiligenceById && computedDataDiligenceById.length"
        class="rate-table-new"
        :style="{
          width:
            computedDataDiligenceById && computedDataDiligenceById.length > 2
              ? '100%'
              : '80%',
        }"
      >
        <thead>
          <tr>
            <th>Chương trình học Tutor</th>
            <th>Tổng số buổi</th>
            <th>Tham gia</th>
            <th>Tỉ lệ tham gia</th>
            <th>Đi muộn</th>
            <th>Nghỉ phép</th>
            <th>Bảo lưu</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in computedDataDiligenceById"
              :key="'td-Diligence' + index">
              <td><strong>{{item.curriculumName}}</strong></td>
            <td>
              {{ item.totalLesson }}
            </td>
            <td>
              {{ item.lessonJoin }}
            </td>
            <td>
              <div class="d-flex justify-center" style="min-width: 75px">
                <div class="my-auto">{{ item.lessonJoinRatio ? item.lessonJoinRatio : '--' }}%</div>
                <up-down-scope
                  v-if="item.compareJoinRatio && ['increase','decrease'].includes(item.compareJoinRatio) && item.comparePointJoinRatio"
                  :percent="true"
                  :value="item.comparePointJoinRatio"
                  :kind="item.compareJoinRatio"
                ></up-down-scope>
              </div>
            </td>
            <td>
              {{ item.lessonLate }}
            </td>
            <td>
              {{ item.onLeave }}
            </td>
            <td>
              <div
                v-if="
                  item.reservation && item.reservation.length
                "
                class="d-flex m-auto justify-center"
              >
                <div class="px-3 py-2">
                  <div
                    v-for="(code, index) in item.reservation"
                    :key="'code' + index"
                    class="d-flex mb-1"
                  >
                    <div v-if="checkShowDate(code.reservationDate, code.returnDate)">
                      <div class="content-reservation text-no-wrap">Đang bảo lưu lớp {{ code.classCode }}</div>
                      <div class="text-no-wrap" style="font-size: 12px">Từ {{ code.reservationDate ? moment(code.reservationDate).format("DD/MM/YYYY"): "-"}} - {{ code.returnDate ? moment(code.returnDate).format("DD/MM/YYYY") : "-" }}</div>
                    </div>
                    <div v-else class="text-center">--</div>
                  </div>
                </div>
              </div>
              <span v-else>--</span>
            </td>
          </tr>
        </tbody>
      </table>
      <note-filter-for-date
        v-if="computedDataDiligenceById && computedDataDiligenceById.length"
        :dateTime="filterForm.dateTime"
      ></note-filter-for-date>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import NoteFilterForDate from './ModalScoreDetail/NoteFilterForDate.vue';
import UpDownScope from './ModalScoreDetail/UpDownScope.vue';

export default {
  components: { NoteFilterForDate, UpDownScope },
  name: 'AttendanceTab',
  data() {
    return {
      moment,
      dataDiligenceByID: [],
      loading: true,
    };
  },
  async mounted() {
    await this.getDataDiligenceByID();
  },
  computed: {
    ...mapState('student_detail_bt', [
      'filterForm',
      'studentBlendedTutorDetail',
      'activeFilterSubject',
    ]),
    computedDataDiligenceById() {
      return this.activeFilterSubject !== 'Tất cả'
        ? this.dataDiligenceByID.filter(
          (e) => e.curriculumName.toLowerCase()
              === this.activeFilterSubject.toLowerCase(),
        )
        : this.dataDiligenceByID;
    },
  },
  watch: {
    'filterForm.dateTime': {
      handler(val) {
        if (val && val.length) {
          this.getDataDiligenceByID();
        }
      },
    },
  },
  methods: {
    ...mapActions('student_detail_bt', ['setListDiligence']),
    async getDataDiligenceByID() {
      this.loading = true;
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        const params = {
          id: this.studentBlendedTutorDetail.lms_core_user_id,
          startTime: this.filterForm.dateTime[0],
          endTime: this.filterForm.dateTime[1],
        };
        const res = await BlendedCareRepository.getListDiligence(params);
        if (res && res.data) {
          this.dataDiligenceByID = res.data;
          this.setListDiligence(res.data);
        }
        if (res && res.errors) {
          this.$swal({
            title: 'Lỗi!',
            text: 'Có lỗi xảy ra. Vui Lòng thử lại !!!',
          });
        }
      }
      this.loading = false;
    },
    checkShowDate(reservationDate, returnDate) {
      const now = moment();
      const reservation = moment(reservationDate, 'YYYY-MM-DD');
      const returnDay = moment(returnDate, 'YYYY-MM-DD');
      return now.isBetween(reservation, returnDay);
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  td {
    background: #F9F4F4;
    color: #000;
  }
}
.rate-table-new {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  th {
    padding: 8px;
    min-width: 120px;
    background: #4D4CAC;
    color: #fff
  }
  td {
    padding: 8px;
    text-align: center;
  }
}
</style>
<style scoped>
.content-reservation {
  color: #C62828;
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
}
.gh-tutor {
  font-size: 10px;
  border-radius: 16px;
  margin-right: 12px;
  background: #cd91d7;
  padding: 8px 16px;
  color: white;
  width: fit-content;
  height: fit-content;
}
.content-none {
  color: #000;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}
</style>
